import { defineComponent } from 'vue'

/**
 * Occupations and unavailabilities shown as warnings by `EventUserAssignment` for an event
 * that is not saved yet: they are fetched for its period when the assignment modal opens.
 */
export default defineComponent({
  data() {
    return {
      occupations: [] as unknown[],
      allUsersAvailabilityItems: [] as unknown[]
    }
  },
  methods: {
    loadAssignmentWarnings(event: { date_from?: unknown; date_to?: unknown }) {
      if (!event.date_from) return

      this.$store
        .dispatch('planning/getAssetsForPeriod', {
          date_from: event.date_from,
          date_to: event.date_to
        })
        .then((response) => {
          this.occupations = response.occupations ?? []
          this.allUsersAvailabilityItems =
            response.users_availability_items ?? []
        })
        .catch(() => {
          // Warnings are optional: the assignment works without them.
        })
    }
  }
})
